export const getAvatar = (name: any) => {
  const colors = [
    "bg-gradient-to-br from-purple-400 to-pink-400",
    "bg-gradient-to-br from-blue-400 to-cyan-400",
  ];
  const colorIndex = name.length % colors.length;
  return colors[colorIndex];
};
